export default [
  {
    path: "/sells",
    name: "sells-list",
    meta: {
      title: "Приходы",
      authRequired: true,
    },
    component: () => import("@/modules/sells/views/items.vue"),
  },
  {
    path: "/sells/:id",
    name: "sells-edit",
    meta: {
      title: "Информация о приходе",
      authRequired: true,
    },
    component: () => import("@/modules/sells/views/edit.vue"),
  },
  {
    path: "/sells/new",
    name: "sells-create",
    meta: {
      title: "Информация о приходе",
      authRequired: true,
    },
    component: () => import("@/modules/sells/views/edit.vue"),
  },
];
